import {
  IconFileTypeCsv,
  IconFileTypeDocx,
  IconFileTypeJpg,
  IconFileTypePng,
  IconFileTypePpt,
  IconFileTypeXls,
  IconFileUnknown,
  IconFolder,
  IconGif,
  IconPdf,
} from '@tabler/icons-react';
import { ReactNode } from 'react';

/** @registry File-type icon map keyed by lowercase extension (plus 'folder' and 'unknown'); read it through fileIcon rather than indexing directly. */
export const IconLookup: Record<string, ReactNode> = {
  folder: <IconFolder title="folder" />,
  ppt: <IconFileTypePpt title="ppt" />,
  pptx: <IconFileTypePpt title="pptx" />,
  pptm: <IconFileTypePpt title="pptm" />,
  csv: <IconFileTypeCsv title="csv" />,
  pdf: <IconPdf title="pdf" />,
  xlsx: <IconFileTypeXls title="xls" />,
  cfb: <IconFileTypeXls title="xls" />,
  xls: <IconFileTypeXls title="xls" />,
  png: <IconFileTypePng title="png" />,
  jpg: <IconFileTypeJpg title="jpg" />,
  jpeg: <IconFileTypeJpg title="jpeg" />,
  docx: <IconFileTypeDocx title="docx" />,
  gif: <IconGif title="gif" />,
  unknown: <IconFileUnknown title="unknown" />,
};

/** @registry Resolves a document/attachment type string to its icon node, falling back to the unknown-file icon. */
export const fileIcon = (type?: string): ReactNode =>
  IconLookup[type ?? ''] ?? IconLookup.unknown;
